module.exports = __webpack_public_path__ + "img/lift.648aeae7.svg";